import { api } from "@breakout/backend/convex/_generated/api"
import type { Maybe } from "@breakout/shared/types/market"
import { convexQuery } from "@convex-dev/react-query"
import { useQuery } from "@tanstack/react-query"
import type { Address } from "viem"

interface TopHoldersArgs {
	marketAddress: Address
}

export function useTopHolders(args: Maybe<TopHoldersArgs>) {
	return useQuery({
		...convexQuery(api.indexer.public.getTopHolders, {
			marketAddress: args?.marketAddress ?? "",
		}),
		enabled: !!args,
	})
}
